import { render } from "./send-templates.vue?vue&type=template&id=13ad145a"
import script from "./send-templates.vue?vue&type=script&lang=js"
export * from "./send-templates.vue?vue&type=script&lang=js"

import "./send-templates.vue?vue&type=style&index=0&id=13ad145a&lang=postcss"
script.render = render

export default script